import { ILayout, ILayoutMetrics } from './ILayout';
import { ISize } from './ISize';

export class FlowLayout implements ILayout {

  private itemWidth: number;
  private itemHeight: number;

  constructor(itemWidth: number, itemHeight: number) {
    this.itemWidth = itemWidth;
    this.itemHeight = itemHeight;
  }

  public metrics(dimensions: ISize): ILayoutMetrics {
    return {
      numberOfRows: Math.max(Math.ceil(dimensions.height / this.itemHeight), 1),
      numberOfCols: Math.max(Math.floor(dimensions.width / this.itemWidth), 1),
      heightOfRowInPx: this.itemHeight
    };
  }

}
